
export const RadioList = {
    'AMES': [{ value: 'C', label: 'Applicant', Title: 'Applicant' },
    { value: 'I', label: 'Individual', Title: 'Individual' },
    { value: 'T', label: 'Consultant', Title: 'Applicant' }],
    'WRS': [{ value: 'C', label: 'Applicant', Title: 'Applicant' },
    { value: 'I', label: 'Individual', Title: 'Individual' },
    { value: 'T', label: 'Consultant', Title: 'Applicant' }],
    'MPS': [{ value: 'A', label: 'Applicant', Title: 'Applicant' },
    { value: 'I', label: 'Individual', Title: 'Individual' },
    { value: 'T', label: 'Consultant', Title: 'Consultant' }],
    'SHAPES': [{ value: 'A', label: 'Applicant', Title: 'Applicant' },
    { value: 'I', label: 'Individual', Title: 'Individual' },
    { value: 'T', label: 'Consultant', Title: 'Consultant' }],
    'Other': [{ value: 'A', label: 'Company', Title: 'Company' },
    { value: 'I', label: 'Individual', Title: 'Individual' },
    { value: 'T', label: 'Consultant', Title: 'Consultant' }],
    'APPS': [{ value: 'A', label: 'Applicant', Title: 'Applicant' },
    { value: 'I', label: 'Individual', Title: 'Individual' },
    { value: 'T', label: 'Consultant', Title: 'Consultant' }],
}